<div class="cookie-overlay" [ngClass]="{ 'show': showBanner || showSettingsPanel }" (click)="hideCustomSettings()">
</div>

<div class="cookie-consent-banner py-4 px-3 px-xxl-5 d-lg-flex align-items-center justify-content-between"
    [ngClass]="{ 'show': showBanner }" *ngIf="showBanner">
    <div class="d-lg-flex col-lg-5 col-12 align-items-center">
        <div class="col-lg-1 col-12 me-lg-4 me-0 order-1">
            <img src="../../../assets/imgs/cookies.png" alt="Cookie Icon" class="img-fluid">
        </div>
        <p class="mb-0 text-lg-start text-center col-12 order-2 px-lg-0 px-5 mt-5 mt-lg-0"> Our website uses cookies. By
            continuing to navigate, we assume you consent to the use of cookies as described in our <a
                href="https://www.odda.co.uk/privacy-policy" target="_blank" rel="noopener noreferrer">Privacy
                Policy</a>.</p>
    </div>
    <div class="mt-5 mt-lg-0 col-lg-6 d-flex flex-lg-row flex-column justify-content-end align-self-end">
        <button class="btn btn-secondary me-2 col-lg-4 col-12 mb-2 mb-lg-0" (click)="acceptCookies()">
            <img src="../../../assets/icons/cookie.png" alt="" class="img-fluid me-1" width="20px"> Accept cookies
        </button>
        <button class="btn btn-outline-primary me-2 col-lg-4 col-12 mb-2 mb-lg-0" (click)="showCustomSettings()">
            Customise Settings</button>
        <button class="btn btn-outline-primary col-lg-2 col-12" (click)="declineCookies()"> Decline</button>
    </div>
</div>

<div class="custom-settings-panel px-4 py-5 justify-content-between col-12" [ngClass]="{ 'show': showSettingsPanel }">
    <div class="d-flex justify-content-between align-items-center">
        <img src="../../../assets/logo/WhiteGreen.png" alt="Odda" height="50px" class="object-fit-contain">
        <button type="button" class="btn btn-sm btn-outline-light" (click)="hideCustomSettings()" aria-label="Close">
            <i class="bi bi-x-lg"></i>
        </button>
    </div>
    <hr>
    <div class="text-start">
        <h3 class="text-start">Privacy Preference Center</h3>
        <p style="font-size: smaller;">
            This website uses cookies and similar technologies, (hereafter “technologies”), which enable us, for
            example, to
            determine how frequently our internet pages are visited, the number of visitors, to configure our offers for
            maximum convenience and efficiency and to support our marketing efforts. These technologies incorporate data
            transfers to third-party providers based in countries without an adequate level of data protection (e. g.
            United
            States). For further information, including the processing of data by third-party providers and the
            possibility
            of revoking your consent at any time, please see your settings under “Consent Preferences” and our
            <a href="https://www.odda.co.uk/privacy-policy" class="text-white" target="_blank"
                rel="noopener noreferrer">Privacy Notice</a>
        </p>
        <div class="d-flex gap-2 mt-3">
            <button class="btn btn-accept-all flex-fill" (click)="acceptCookies()">Accept All</button>
            <button class="btn btn-reject-all flex-fill" (click)="declineCookies()">Reject All</button>
        </div>
    </div>
    <hr>
    <div class="text-start">
        <h3 class="text-start">Privacy Preference Center</h3>
        
        <!-- Strictly Necessary -->
        <div class="row align-items-center mb-1">
            <div class="col-8 preference-header" (click)="toggleSection('necessary')">
                <i class="bi" [ngClass]="expandedSection === 'necessary' ? 'bi-dash' : 'bi-plus'"></i> Strictly Necessary Cookies
            </div>
            <div class="col-4 d-flex justify-content-end text-nowrap" style="color: #5FBF92;">
                Always Active
            </div>
        </div>
        <div class="preference-details" *ngIf="expandedSection === 'necessary'">
            These cookies are necessary for the website to function and cannot be switched off in our systems. They are usually only set in response to actions made by you which amount to a request for services, such as setting your privacy preferences, logging in or filling in forms.
        </div>
        <hr>

        <!-- Performance Cookies -->
        <div class="row align-items-center mb-1">
            <div class="col-8 preference-header" (click)="toggleSection('performance')">
                <i class="bi" [ngClass]="expandedSection === 'performance' ? 'bi-dash' : 'bi-plus'"></i> Performance Cookies
            </div>
            <div class="col-4 d-flex justify-content-end">
                <div class="form-check form-switch m-0">
                    <input class="form-check-input" [(ngModel)]="performanceCookies" type="checkbox" role="switch"
                        name="performanceCookies" id="perfCookiesSwitch">
                </div>
            </div>
        </div>
        <div class="preference-details" *ngIf="expandedSection === 'performance'">
            These cookies allow us to count visits and traffic sources so we can measure and improve the performance of our site. They help us know which pages are the most and least popular and see how visitors move around the site. All information these cookies collect is aggregated and therefore anonymous.
        </div>
        <hr>

        <!-- Functional Cookies -->
        <div class="row align-items-center mb-1">
            <div class="col-8 preference-header" (click)="toggleSection('functional')">
                <i class="bi" [ngClass]="expandedSection === 'functional' ? 'bi-dash' : 'bi-plus'"></i> Functional Cookies
            </div>
            <div class="col-4 d-flex justify-content-end">
                <div class="form-check form-switch m-0">
                    <input class="form-check-input" [(ngModel)]="functionalCookies" type="checkbox" role="switch"
                        name="functionalCookies" id="funcCookiesSwitch">
                </div>
            </div>
        </div>
        <div class="preference-details" *ngIf="expandedSection === 'functional'">
            These cookies enable the website to provide enhanced functionality and personalisation. They may be set by us or by third party providers whose services we have added to our pages. If you do not allow these cookies then some or all of these services may not function properly.
        </div>
        <hr>

        <!-- Targeting Cookies -->
        <div class="row align-items-center mb-1">
            <div class="col-8 preference-header" (click)="toggleSection('targeting')">
                <i class="bi" [ngClass]="expandedSection === 'targeting' ? 'bi-dash' : 'bi-plus'"></i> Targeting Cookies
            </div>
            <div class="col-4 d-flex justify-content-end">
                <div class="form-check form-switch m-0">
                    <input class="form-check-input" [(ngModel)]="targetingCookies" type="checkbox" role="switch"
                        name="targetingCookies" id="targetCookiesSwitch">
                </div>
            </div>
        </div>
        <div class="preference-details" *ngIf="expandedSection === 'targeting'">
            These cookies may be set through our site by our advertising partners. Learn more on <a href="https://business.safety.google/privacy/" target="_blank" rel="noopener noreferrer" class="text-white text-decoration-underline">Google's Business Data Responsibility Site</a>.
        </div>
        <hr>
    </div>

    <div class="d-flex justify-content-end mt-4 mb-4">
        <button class="btn btn-success px-4 py-2 text-white" (click)="confirmSelection()">Save Preferences</button>
    </div>
</div>